import { render, staticRenderFns } from "./DrawerTable.vue?vue&type=template&id=5e71db3e&scoped=true&"
import script from "./DrawerTable.vue?vue&type=script&lang=js&"
export * from "./DrawerTable.vue?vue&type=script&lang=js&"
import style0 from "./DrawerTable.vue?vue&type=style&index=0&id=5e71db3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e71db3e",
  null
  
)

export default component.exports